import { z } from 'zod';

export interface WithdrawAmountValidationOptions {
  minWithdraw?: number;
  maxWithdraw?: number;
  maxWithdrawMessage?: string;
  maxAvailable?: number;
  requireMaxAvailable?: boolean;
  totalAmount?: number;
}

export const createWithdrawAmountSchema = (
  options: WithdrawAmountValidationOptions = {}
): z.ZodString => {
  const {
    minWithdraw,
    maxWithdraw,
    maxWithdrawMessage,
    maxAvailable,
    requireMaxAvailable = false,
    totalAmount,
  } = options;

  let schema = z
    .string()
    .refine(val => {
      if (!minWithdraw) return false;

      const isEmpty = val.trim() === '' || Number(val) === 0;
      if (isEmpty) return false;
      return Number(val) >= minWithdraw;
    })
    .superRefine((val, ctx) => {
      if (maxWithdraw && Number(val) > maxWithdraw) {
        ctx.addIssue({
          code: 'too_big',
          origin: 'number',
          maximum: maxWithdraw,
          inclusive: true,
          message: maxWithdrawMessage,
        });
      }
    })
    .refine(val => {
      if (requireMaxAvailable && !maxAvailable) return false;
      if (!maxAvailable) return true;
      return Number(val) <= maxAvailable;
    });

  if (totalAmount !== undefined && maxAvailable !== undefined) {
    schema = schema.superRefine((val, ctx) => {
      if (!totalAmount || !val) return;
      if (totalAmount > maxAvailable) {
        ctx.addIssue({
          code: 'custom',
          message: '',
        });
      }
    });
  }

  return schema;
};
